export enum TemplateCreationType {
    Admin = 0,
    ClientEvent = 2,
    ClientCampaign = 3,
    Client = 1,
    AdminEvent = 4,
    AdminCampaign = 5
}
